import React, { useState, useEffect, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import AdminLayout from '../components/AdminLayout';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { RefreshCw, AlertTriangle, CheckCircle2, Clock } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import api from '../api';

const AdminBiletinialSync = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [running, setRunning] = useState(false);
  const { toast } = useToast();

  const loadStatus = useCallback(async () => {
    try {
      const res = await api.get('/admin/biletinial-sync/status');
      setStatus(res.data);
    } catch (err) {
      toast({ title: 'Hata', description: 'Durum bilgisi alinamadi', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  }, [toast]);

  useEffect(() => {
    loadStatus();
  }, [loadStatus]);

  const handleRun = async () => {
    setRunning(true);
    try {
      await api.post('/admin/biletinial-sync/run');
      toast({ title: 'Basladi', description: 'Senkronizasyon arka planda basladi, 30-60 saniye surer' });
      setTimeout(() => {
        loadStatus();
        setRunning(false);
      }, 45000);
    } catch (err) {
      const detail = err?.response?.data?.detail || 'Bilinmeyen hata';
      toast({ title: 'Hata', description: detail, variant: 'destructive' });
      setRunning(false);
    }
  };

  const eksikVarMi = status?.eksik_filmler && !status.eksik_filmler.includes('Eksik film yok');

  return (
    <AdminLayout>
      <Helmet><title>Biletinial Senkronizasyonu</title></Helmet>
      <div className="p-6 space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">Biletinial Senkronizasyonu</h1>
          <Button onClick={handleRun} disabled={running || status?.calisma_devam_ediyor}>
            <RefreshCw className={`mr-2 h-4 w-4 ${running ? 'animate-spin' : ''}`} />
            {running || status?.calisma_devam_ediyor ? 'Calisiyor...' : 'Simdi Calistir'}
          </Button>
        </div>

        {loading ? (
          <p>Yukleniyor...</p>
        ) : (
          <>
            <Card className="p-4">
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <Clock className="h-4 w-4" />
                Son calisma: {status?.son_calisma_zamani || 'henuz calismadi'}
              </div>
            </Card>

            <Card className={`p-4 ${eksikVarMi ? 'border-orange-400' : 'border-green-400'}`}>
              <div className="flex items-center gap-2 mb-2">
                {eksikVarMi ? (
                  <AlertTriangle className="h-5 w-5 text-orange-500" />
                ) : (
                  <CheckCircle2 className="h-5 w-5 text-green-500" />
                )}
                <h2 className="font-semibold">Eksik Filmler</h2>
              </div>
              <pre className="whitespace-pre-wrap text-sm bg-gray-50 p-3 rounded">
                {status?.eksik_filmler || 'Veri yok'}
              </pre>
            </Card>

            <Card className="p-4">
              <h2 className="font-semibold mb-2">Son Calisma Loglari</h2>
              <pre className="whitespace-pre-wrap text-xs bg-gray-900 text-gray-100 p-3 rounded max-h-96 overflow-y-auto">
                {status?.son_log || 'Log yok'}
              </pre>
            </Card>
          </>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminBiletinialSync;